import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import TabPanel, { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { EmptyItem, GroupItem, Label, SimpleItem, Tab, TabbedItem } from "devextreme-react/form";
import { Button } from "devextreme-react/button";

interface GestionSaisieDePaiementProps {
  setActive?: (shouldClose: boolean) => void; // Define onClose as a function that doesn't take any arguments and doesn't return anything
}

const PopupFicheClient = ({ setActive }: GestionSaisieDePaiementProps) => {
  
  return (
    <div className='wrapper-content-pop'>
      <div style={{ flex: 1 }}>
        <div className="container-saisie-paiement" id="calcul-saisie">
          <div className="box-saisie-paiement">

          </div>
        </div>
      </div>
    </div >
  )
}

export default PopupFicheClient;